import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const CreateGiftVoucher = lazy(() => import("../components/CreateGiftVoucher"));

const GiftVoucherConfigRoute: RouteObject = {
  path: "/gift-vouchers/create",
  element: <CreateGiftVoucher />,
  children: [
    {
      path: "view/:code",
      element: <CreateGiftVoucher />,
    },
    {
      path: 'clone/:code',
      element: <CreateGiftVoucher />,
    },
    {
      path: 'edit/:code',
      element: <CreateGiftVoucher />,
    },
  ],
};

export default GiftVoucherConfigRoute;
